import React from 'react';
import { Link as RouterLink, useSearchParams } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { obtecPanelPath, obtecPanels, ObtecPanelKey } from '../data/obtecPanels';

const PesquisaObtecPainel: React.FC = () => {
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const activeKey: ObtecPanelKey = searchParams.get('painel') === 'digital' ? 'digital' : 'economico';
  const activePanel = obtecPanels[activeKey];

  return (
    <Box
      sx={{
        mx: { xs: -2, md: -4 },
        mb: { xs: -6, md: -8 },
        minHeight: 'calc(100svh - 64px)',
        bgcolor: '#08192e',
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 3, md: 5 },
          py: { xs: 2, md: 2.5 },
          color: '#fff',
          background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 58%, ${theme.palette.secondary.main} 100%)`,
          borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,
        }}
      >
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }} justifyContent="space-between">
          <Box>
            <Typography variant="overline" sx={{ color: 'rgba(255,255,255,0.78)', fontWeight: 800, letterSpacing: 1 }}>
              OBTEC
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                lineHeight: 1.16,
                fontSize: { xs: '1.55rem', sm: '1.9rem', md: '2.125rem' },
              }}
            >
              {activePanel.label}
            </Typography>
            <Typography sx={{ color: 'rgba(255,255,255,0.82)', mt: 0.5 }}>{activePanel.subtitle}</Typography>
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="stretch">
            {(Object.keys(obtecPanels) as ObtecPanelKey[]).map((key) => (
              <Button
                key={key}
                component={RouterLink}
                to={obtecPanelPath(key)}
                variant={activeKey === key ? 'contained' : 'outlined'}
                aria-current={activeKey === key ? 'page' : undefined}
                sx={{
                  color: '#fff',
                  borderColor: 'rgba(255,255,255,0.5)',
                  bgcolor: activeKey === key ? (key === 'economico' ? '#e5800c' : '#0755bd') : 'transparent',
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  '&:hover': { bgcolor: activeKey === key ? (key === 'economico' ? '#c76d07' : '#0649a2') : 'rgba(255,255,255,0.12)', borderColor: '#fff' },
                }}
              >
                {key === 'economico' ? 'Econômico Estadual' : 'Transformação Digital'}
              </Button>
            ))}
            <Button component="a" href={activePanel.url} target="_blank" rel="noopener noreferrer" variant="contained" color="secondary" sx={{ fontWeight: 800, whiteSpace: 'nowrap' }}>
              Abrir em nova guia
            </Button>
          </Stack>
        </Stack>
      </Box>

      <Box
        sx={{
          height: {
            xs: 'calc(100svh - 168px)',
            sm: 'calc(100svh - 148px)',
            md: 'calc(100vh - 126px)',
          },
          minHeight: { xs: 520, sm: 620, md: 680 },
          bgcolor: '#0b1220',
        }}
      >
        <Box
          component="iframe"
          key={activeKey}
          title={`OBTEC 2026 - ${activePanel.label}`}
          src={activePanel.url}
          allowFullScreen
          loading="eager"
          sx={{
            display: 'block',
            width: '100%',
            height: '100%',
            border: 0,
          }}
        />
      </Box>
    </Box>
  );
};

export default PesquisaObtecPainel;
